var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup19(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(0.222 -0.333)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    transform: "translate(-0.222 0.333)",
    fill: "#6fda44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-upwork",
    "data-name": "Icon simple-upwork",
    d: "M24.978,18.246a6.6,6.6,0,0,1-4.137-1.651l.307-1.448.011-.057c.279-1.538,1.143-4.118,3.82-4.118a3.637,3.637,0,1,1,0,7.274Zm0-10.954c-3.417,0-6.069,2.219-7.146,5.875a30.05,30.05,0,0,1-3.616-7.929H10.534v9.571a3.426,3.426,0,1,1-6.852,0V5.238H0v9.571a7.108,7.108,0,1,0,14.216,0v-1.6a22.586,22.586,0,0,0,2.656,4.335L14.621,28.137h3.764l1.632-7.684a9.074,9.074,0,0,0,4.96,1.492,7.327,7.327,0,0,0,0-14.654Z",
    transform: "translate(8.667 7.762)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup19);
export default __webpack_public_path__ + "static/media/Group 19.559e87df75d09db84867526b9d83e05d.svg";
export { ForwardRef as ReactComponent };